import React from 'react'
import { CustomerList } from '../../components'

const Customer = () => {
  return (
    <div>
      <CustomerList />
    </div>
  )
}

export default Customer